import Autocomplete from "react-google-autocomplete";
import styles from "../../styles/Select.module.css";
import { GOOGLE_PLACES_API_KEY } from "../../config";
import { extractCountryCode } from "../../utils/places";

interface DistanceLocationInputProps {
  label: string;
  value: string;
  placeholder: string;
  onChange: (val: string | undefined, countryCode?: string | null) => void;
  setCalculationError: any;
}

const DistanceLocationInput: React.FC<DistanceLocationInputProps> = ({
  label,
  value,
  placeholder,
  onChange,
  setCalculationError,
}) => {
  return (
    <div className={`${styles.customSelect} translate-dynamic delayed-fadein`}>
      <label className={styles.inputLabel}>{label}</label>
      <Autocomplete
        apiKey={GOOGLE_PLACES_API_KEY}
        placeholder={placeholder}
        className={`selected-text`}
        defaultValue={value}
        options={{types: ['locality', 'administrative_area_level_3', 'airport', 'point_of_interest']}}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setCalculationError('');
          if (!e?.target?.value) {
            onChange('');
          }
        }}
        onPlaceSelected={(place) => {
          onChange(place?.formatted_address, extractCountryCode(place));
        }}
      />
    </div>
  );
}

export default DistanceLocationInput;
